module.exports = __webpack_public_path__ + "img/vs.686434e1.png";